import { BookOpen, Globe, Mail, Sparkles, Webhook, Megaphone } from "lucide-react";
import type { ContentConnectorType } from "@/lib/composerCore";

export const ConnectorTypeIcon = ({ type, className }: { type: ContentConnectorType; className?: string }) => {
  if (type === "email") return <Mail className={className} />;
  if (type === "kit") return <Sparkles className={className} />;
  if (type === "bento") return <Megaphone className={className} />;
  if (type === "wordpress") return <Globe className={className} />;
  if (type === "wordpress_self_hosted") return <Globe className={className} />;
  if (type === "ghost") return <Sparkles className={className} />;
  if (type === "substack_unofficial") return <BookOpen className={className} />;
  if (type === "beehiiv") return <Megaphone className={className} />;
  if (type === "buttondown") return <Mail className={className} />;
  return <Webhook className={className} />;
};
